import { Component } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { connect } from "react-redux";
import { Button, Card, message, Spin } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { adminService } from "../../_services/admin.service";

class DistrictOrder extends Component {
  static contextType = LanguageContext;

  state = {
    district_data: [],
    loading: false,
    saving: false,
  };

  componentDidMount() {
    if (["4", "9", "10"].includes(String(this.props.user?.role))) {
      this.loadDistricts();
    }
  }

  loadDistricts = () => {
    const cityId = this.props.user?.cityId;

    if (!cityId) {
      message.error("City not found.");
      return;
    }

    this.setState({
      loading: true,
    });

    adminService
      .GetOrderDistrict(cityId)
      .then((res) => {
        console.log("Get Order District Response:", res);

        const districts = res?.data || [];

        /*
         * If saved order exists:
         *     use saved order
         *
         * If saved order does not exist:
         *     use default district order
         */

        const hasSavedOrder = districts.some(
          (district) => district.order !== null && district.order !== undefined,
        );

        let district_data = [];

        if (hasSavedOrder) {
          // Existing order available
          district_data = [...districts]
            .sort((a, b) => {
              const orderA =
                a.order !== null && a.order !== undefined
                  ? Number(a.order)
                  : 999999;

              const orderB =
                b.order !== null && b.order !== undefined
                  ? Number(b.order)
                  : 999999;

              return orderA - orderB;
            })
            .map((district, index) => ({
              ...district,
              order: index + 1,
            }));
        } else {
          // No saved order
          // Keep default API order
          district_data = districts.map((district, index) => ({
            ...district,
            order: index + 1,
          }));
        }

        this.setState({
          district_data,
          loading: false,
        });
      })
      .catch((error) => {
        console.log("Get Order District Error:", error);

        message.error(
          error?.response?.data?.message || "Failed to load districts.",
        );

        this.setState({
          loading: false,
        });
      });
  };

  handleDragEnd = (result) => {
    const { destination, source } = result;

    // Dropped outside
    if (!destination) {
      return;
    }

    // Same position
    if (destination.index === source.index) {
      return;
    }

    const items = Array.from(this.state.district_data);

    // Remove dragged district
    const [removed] = items.splice(source.index, 1);

    // Add at new position
    items.splice(destination.index, 0, removed);

    // Recalculate order
    const updatedData = items.map((district, index) => ({
      ...district,
      order: index + 1,
    }));

    this.setState({
      district_data: updatedData,
    });
  };

  handleSubmit = () => {
    const { district_data } = this.state;

    const cityId = this.props.user?.cityId;

    if (!cityId) {
      message.error("City not found.");
      return;
    }

    if (!district_data.length) {
      message.error("No districts found.");
      return;
    }

    const data = {
      cityId,

      districts: district_data.map((district, index) => ({
        districtId: district.id,
        order: index + 1,
      })),
    };

    console.log("Update District Order Payload:", data);

    this.setState({
      saving: true,
    });

    adminService
      .UpdateDistrictOrder(data)
      .then((res) => {
        console.log("Update District Order Response:", res);

        message.success(
          res?.data?.message || "District order updated successfully.",
        );

        // Reload from DB after save
        this.loadDistricts();
      })
      .catch((error) => {
        console.log("Update District Order Error:", error);

        message.error(
          error?.response?.data?.message || "Failed to update district order.",
        );
      })
      .finally(() => {
        this.setState({
          saving: false,
        });
      });
  };

  render() {
    const { district_data, loading, saving } = this.state;
    const { t } = this.context;
    return (
      <div style={{ padding: 20 }}>
        <Card
          title="Sequance Order"
          extra={
            <>
              <div className="stats-card stats-accused">
                <span className="stats-text">
                  {t("total")}: {district_data.length}
                </span>
              </div>
            </>
          }
        >
          {loading ? (
            <div
              style={{
                textAlign: "center",
                padding: 40,
              }}
            >
              <Spin />
            </div>
          ) : (
            <DragDropContext onDragEnd={this.handleDragEnd}>
              <Droppable droppableId="district-list">
                {(provided, snapshot) => (
                  <div>
                    {/* Header */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "12px 15px",
                        marginBottom: 8,
                        backgroundColor: "#fafafa",
                        border: "1px solid #d9d9d9",
                        borderRadius: 6,
                        fontWeight: 600,
                        color: "#333",
                      }}
                    >
                      {/* Sr No */}
                      <span
                        style={{
                          width: 80,
                        }}
                      >
                        Sr. No.
                      </span>

                      {/* District */}
                      <span style={{ flex: 1 }}>District Name</span>
                      {/* Order */}
                      <span>Order</span>
                    </div>

                    {/* District List */}
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      style={{
                        padding: 10,
                        minHeight: 100,
                        backgroundColor: snapshot.isDraggingOver
                          ? "#f0f0f0"
                          : "#ffffff",
                        border: "1px solid #e8e8e8",
                        borderRadius: 6,
                      }}
                    >
                      {district_data.map((district, index) => (
                        <Draggable
                          key={String(district.id)}
                          draggableId={String(district.id)}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                display: "flex",
                                alignItems: "center",

                                padding: "12px 15px",
                                marginBottom: 8,

                                // Dark color while dragging
                                backgroundColor: snapshot.isDragging
                                  ? "#434343"
                                  : "#ffffff",

                                color: snapshot.isDragging
                                  ? "#ffffff"
                                  : "#333333",

                                border: snapshot.isDragging
                                  ? "1px solid #262626"
                                  : "1px solid #d9d9d9",

                                borderRadius: 6,

                                cursor: "grab",

                                // Animation
                                transition:
                                  "background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease",

                                boxShadow: snapshot.isDragging
                                  ? "0 8px 20px rgba(0,0,0,0.25)"
                                  : "0 1px 3px rgba(0,0,0,0.05)",

                                ...provided.draggableProps.style,
                              }}
                            >
                              {/* Sr No */}
                              <span
                                style={{
                                  width: 80,
                                  fontWeight: 500,
                                }}
                              >
                                {index + 1}
                              </span>

                              {/* District Name */}
                              <span
                                style={{
                                  flex: 1,
                                  fontSize: 15,
                                  fontWeight: 500,
                                }}
                              >
                                {district.DistrictName}
                              </span>
                              {/* Order */}
                              <span
                                style={{
                                  fontWeight: 600,
                                }}
                              >
                                {index + 1}
                              </span>
                            </div>
                          )}
                        </Draggable>
                      ))}

                      {provided.placeholder}

                      {!district_data.length && (
                        <div
                          style={{
                            textAlign: "center",
                            padding: 30,
                            color: "#999",
                          }}
                        >
                          No districts found.
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          )}

          <div style={{ textAlign: "right", marginBottom: 16 }}>
            <Button
              type="primary"
              onClick={this.handleSubmit}
              loading={saving}
              disabled={!district_data.length}
            >
              Save Order
            </Button>
          </div>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;

  const { user } = authentication;

  return {
    user,
    users,
    professionals,
  };
}

const connectedDistrictOrder = connect(mapStateToProps)(DistrictOrder);

export { connectedDistrictOrder as DistrictOrder };
